import ContentBlocks from '@/modules/foundation/sanity/content-blocks/ContentBlocks';
import PageHead from '@/modules/foundation/sanity/page-head/PageHead';

import type {PageBySlugQueryResult} from './query';

interface Props {
	page: PageBySlugQueryResult;
}

export default function Page({page}: Props) {
	const {content, pageHeadings} = page ?? {};

	return (
		<>
			{pageHeadings && <PageHead pageHeads={pageHeadings} />}
			{content && content.length > 0 && <ContentBlocks content={content} />}
		</>
	);
}
